import React, { Component } from "react";
import { Row, Col } from "antd";
import { RiCheckboxCircleFill, RiCheckboxCircleLine, RiCloseCircleFill, RiCloseCircleLine } from "react-icons/ri";

export default class StockCheckerPrototype extends Component {
    constructor(props) {
        super(props);
        this.state = { isButtonActive: 'na' };
        this.onClick = this.onClick.bind(this);
    }

    onClick(check) {
        // if there is a change in status then run the code, otherwise leave it be
        if (check !== this.state.isButtonActive) {
            this.setState({
                isButtonActive: check
            });

            if (this.props.runFunction) {
                this.props.runFunction(check);
            }
        }
    }

    render() {
        const iconSize = 48;
        const iconStyle = {
            cursor: 'pointer',
            transition: 'color 0.2s ease'
        };

        const checkIconStyle = {
            ...iconStyle,
            marginRight: "10px",
            color: this.state.isButtonActive === true ? '#52c41a' : '#d9d9d9'
        };

        const crossIconStyle = {
            ...iconStyle,
            marginLeft: "10px", 
            color: this.state.isButtonActive === false ? '#ff4d4f' : '#d9d9d9'
        };

        return (
            <Col span={24}>
                {this.state.isButtonActive === true ? (
                    <RiCheckboxCircleFill 
                        size={iconSize}
                        style={checkIconStyle}
                        onClick={() => this.onClick(true)}
                    />
                ) : (
                    <RiCheckboxCircleLine 
                        size={iconSize}
                        style={checkIconStyle}
                        onClick={() => this.onClick(true)}
                    />
                )}
                
                {this.state.isButtonActive === false ? (
                    <RiCloseCircleFill 
                        size={iconSize}
                        style={crossIconStyle}
                        onClick={() => this.onClick(false)}
                    />
                ) : (
                    <RiCloseCircleLine 
                        size={iconSize}
                        style={crossIconStyle}
                        onClick={() => this.onClick(false)}
                    />
                )}
            </Col>
        );
    }
}